import React from "react";
import arrowWhite from "../../icons/ArrowWhite.svg";
import arrowBlue from "../../icons/ArrowBlue.svg";
import share from "../../icons/share.svg";
import exit from "../../icons/exit.svg";
import edit from "../../icons/edit.svg";
import downloadData from "../../icons/downloadData.svg";
import save from "../../icons/save.svg";
import { ButtonVariant } from "../../types/constants";

type ButtonProps = {
    text: string;
    variant?: ButtonVariant;
    disabled?: boolean;
};

const baseClasses =
    "w-full lap:w-[310px] xl:w-[410px] h-[54px] flex items-center justify-between uppercase border rounded-md px-5 py-4 text-base font-normal transition-all duration-300 ease-out";

const ButtonStyles: Record<ButtonVariant, string> = {
    [ButtonVariant.PRIMARY]: "bg-background-400 text-text-400 border-text-400 hover:bg-background-500",
    [ButtonVariant.SECONDARY]: "bg-background-100 text-primary-400 border-primary-400 hover:font-medium",
    [ButtonVariant.BACK]: "bg-background-100 text-primary-400 border-primary-400 hover:font-medium",
    [ButtonVariant.SHARE]: "bg-background-400 text-text-400 border-text-400 hover:bg-background-500",
    [ButtonVariant.EXIT]: "bg-gray-400 text-white hover:bg-gray-500",
    [ButtonVariant.EDIT]: "bg-background-400 text-text-400 border-text-400 hover:bg-background-500",
    [ButtonVariant.DOWNLOAD]: "bg-background-400 text-text-400 border-text-400 hover:bg-background-500",
    [ButtonVariant.SAVE]: "bg-background-400 text-text-400 border-text-400 hover:bg-background-500",
};

const ButtonIcons: Record<ButtonVariant, string> = {
    [ButtonVariant.PRIMARY]: arrowWhite,
    [ButtonVariant.SECONDARY]: arrowBlue,
    [ButtonVariant.BACK]: arrowBlue,
    [ButtonVariant.SHARE]: share,
    [ButtonVariant.EXIT]: exit,
    [ButtonVariant.EDIT]: edit,
    [ButtonVariant.DOWNLOAD]: downloadData,
    [ButtonVariant.SAVE]: save,
};

export default function Button({
    text,
    variant = ButtonVariant.PRIMARY,
    className,
    ...rest
}: ButtonProps & React.HTMLAttributes<HTMLButtonElement>) {
    return (
        <button className={`${baseClasses} ${ButtonStyles[variant]} ${className || ""}`} {...rest}>
            <span>{text}</span>
            <img
                src={ButtonIcons[variant]}
                alt=""
                className={`w-4 h-4 transition-all duration-300 ease-out ${
                    variant === ButtonVariant.SECONDARY || variant === ButtonVariant.SHARE ? "hover:scale-105" : ""
                } ${variant === ButtonVariant.BACK ? "-rotate-90" : ""}`}
            />
        </button>
    );
}
